import CrossIcon from './CrossIcon';

export default CrossIcon;
